import { FilterValue } from "../Filters/FilterValue";

/** Channel filter — B2C / B2B */
export const SWAYY_CHANNEL_OPTIONS: FilterValue[] = [
  { id: "b2c", value: "B2C" },
  { id: "b2b", value: "B2B" },
];

export const SWAYY_ORDER_STATUS_ALL_TAB = "all";
export const SWAYY_ORDER_DEFAULT_STATUS_TAB = "confirmed";

/** Order status filter / detail status menu */
export const SWAYY_ORDER_STATUS_OPTIONS: FilterValue[] = [
  { id: "pending_payment", value: "Pending Payment" },
  { id: "confirmed", value: "Confirmed" },
  { id: "processing", value: "Processing" },
  { id: "partially_shipped", value: "Partially Shipped" },
  { id: "shipped", value: "Shipped" },
  { id: "out_for_delivery", value: "Out for Delivery" },
  { id: "delivered", value: "Delivered" },
  { id: "cancelled", value: "Cancelled" },
  { id: "refunded", value: "Refunded" },
];

/** Listing tabs: All first, then every order status. */
export const SWAYY_ORDER_STATUS_TABS: FilterValue[] = [
  { id: SWAYY_ORDER_STATUS_ALL_TAB, value: "All" },
  ...SWAYY_ORDER_STATUS_OPTIONS,
];

/** Payment status filter */
export const SWAYY_PAYMENT_STATUS_OPTIONS: FilterValue[] = [
  { id: "paid", value: "Paid" },
  { id: "unpaid", value: "Unpaid" },
];

export const getSwayyOrderStatusLabel = (status: string): string =>
  SWAYY_ORDER_STATUS_OPTIONS.find((option) => option.id === status)?.value ??
  status;

export type SwayyStatusTone =
  | "pine"
  | "success"
  | "warning"
  | "danger"
  | "muted";

/** Badge tone for status / payment chips */
export const getSwayyStatusTone = (status: string): SwayyStatusTone => {
  const value = (status || "").toLowerCase();
  if (
    [
      "confirmed",
      "delivered",
      "shipped",
      "paid",
      "prepaid",
      "out_for_delivery",
    ].includes(value)
  ) {
    return "success";
  }
  if (
    ["pending_payment", "processing", "partially_shipped", "cod"].includes(
      value,
    )
  ) {
    return "pine";
  }
  if (["cancelled", "refunded", "unpaid"].includes(value)) {
    return "danger";
  }
  return "muted";
};
